// extracted by mini-css-extract-plugin
export default {"WhiteButton":"WhiteButton_WhiteButton__z7DlJ","icon":"WhiteButton_icon__skKwd"};